import React from 'react';
import { Paper, Box, Typography, Skeleton } from '@mui/material';

const MUIStatCard = ({
  title,
  value,
  icon,
  trend,
  trendDirection,
  loading = false,
  onClick,
  isAlert = false,
  alertColor = '#f44336',
  sx = {},
  ...props
}) => {
  const { trendDirection: _, isAlert: __, alertColor: ___, ...domProps } = props;
  if (loading) {
    return (
      <Paper 
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: 2,
          cursor: onClick ? 'pointer' : 'default',
          transition: 'all 0.2s ease-in-out',
          '&:hover': onClick ? { 
            transform: 'translateY(-4px)',
            boxShadow: 3 
          } : {},
          ...sx
        }}
        onClick={onClick}
        {...domProps}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Skeleton variant="text" width={80} height={24} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={60} height={40} />
          </Box>
          <Skeleton variant="circular" width={48} height={48} />
        </Box>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: 2,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        width: '100%',
        height: '100%',
        minHeight: 160,
        display: 'flex',
        flexDirection: 'column',
        ...(isAlert && {
          bgcolor: `${alertColor}20`,
          border: `2px solid ${alertColor}`,
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: `0 4px 20px ${alertColor}40`,
            bgcolor: `${alertColor}30`
          }
        }),
        ...(!isAlert && {
          '&:hover': onClick ? {
            transform: 'translateY(-4px)',
            boxShadow: 3
          } : {}
        }),
        ...sx
      }}
      onClick={onClick}
      {...domProps}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, flex: 1 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 'medium', wordBreak: 'break-word', fontSize: '1.25rem' }}>
            {value}
          </Typography>
          {trend && (
            <Typography
              variant="body2"
              color={trendDirection === 'up' ? 'success.main' : trendDirection === 'down' ? 'error.main' : 'text.secondary'}
              sx={{
                display: 'flex',
                alignItems: 'center',
                mt: 0.5,
                fontSize: '0.75rem'
              }}
            >
              {trendDirection === 'up' ? '↑' : trendDirection === 'down' ? '↓' : '→'} {trend}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            fontSize: '1.5rem',
            bgcolor: isAlert ? `${alertColor}40` : 'action.hover',
            color: isAlert ? alertColor : 'inherit',
            width: 40,
            height: 40,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          {icon}
        </Box>
      </Box>
    </Paper>
  );
};

export default MUIStatCard;
